import React, {
    ReactElement, useState,
} from "react";
import { Form } from "react-bootstrap";
import { BiPencil, BiTrash } from "react-icons/bi";
import Confirm from "../../../../components/confirm/Confirm";
import FieldType, { UserType } from "../../../../components/pickers/field-type/FieldType";
import { FormFieldType } from "../../../../__generated__/api";
import { createId } from "./base";

type Json = Record<string, unknown>;

export default function OutputList({
    json, onChange, parentId,
}: {
    json : Json[];
    onChange: (value: Json[]) => void;
    parentId: string;

}): ReactElement {
    const [editTemplate, setEditTemplate] = useState<Json | undefined>();

    return (
        <>
            {editTemplate != null && (
                <Confirm
                    shouldShow
                    confirmText="Save"
                    size="lg"
                    className="h-auto"
                    onHide={() => setEditTemplate(undefined)}
                    onConfirm={evt => {
                        evt?.stopPropagation();
                        const parameters = (json ?? []).filter(row => row.id !== editTemplate.id);

                        if (editTemplate) {
                            onChange([
                                ...parameters,
                                (editTemplate as Json),
                            ]);
                        }

                        setEditTemplate(undefined);
                    }}
                >
                    <div className="d-flex">
                        <div className="col">
                            <Form.Group className="mb-2">
                                <Form.Label className="fw-bolder">Id</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Id"
                                    required
                                    onChange={evt => setEditTemplate({ ...editTemplate, id: evt.target.value })}
                                    value={editTemplate.id as string ?? ""}
                                />
                                <div>
                                    <button
                                        type="button"
                                        className="btn btn-none btn-sm"
                                        onClick={() => setEditTemplate({
                                            ...editTemplate,
                                            id: `urn:fq:workflow-service-action-output:`
                                            + `(${parentId},${createId()})`,
                                        })}
                                    >
                                        Generate Id
                                    </button>
                                </div>
                                <Form.Text>
                                    The id of the parameter
                                </Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-2">
                                <Form.Label className="fw-bolder">Name</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Name"
                                    required
                                    onChange={evt => setEditTemplate({ ...editTemplate, name: evt.target.value })}
                                    value={editTemplate.name as string ?? ""}
                                />
                                <Form.Text>
                                    The name of the parameter
                                </Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-2">
                                <Form.Label className="fw-bolder">Description</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="Description"
                                    required
                                    as="textarea"
                                    onChange={evt => setEditTemplate({ ...editTemplate, description: evt.target.value })}
                                    value={editTemplate.description as string ?? ""}
                                />
                                <Form.Text>
                                    The description of the parameter
                                </Form.Text>
                            </Form.Group>
                            <Form.Group className="mb-2">
                                <Form.Label className="fw-bolder">AI Prompt</Form.Label>
                                <Form.Control
                                    type="text"
                                    placeholder="AI Prompt"
                                    as="textarea"
                                    onChange={evt => setEditTemplate({ ...editTemplate, aiPrompt: evt.target.value })}
                                    value={editTemplate.aiPrompt as string ?? ""}
                                />
                                <Form.Text>
                                    The aiPrompt of the parameter
                                </Form.Text>
                            </Form.Group>

                            <Form.Group className="mb-2">
                                <Form.Label className="fw-bolder">Type</Form.Label>
                                <FieldType
                                    className="text-gray"
                                    type={UserType.ADMINISTRATOR}
                                    onChange={value => setEditTemplate({ ...editTemplate, type: value as string })}
                                    value={editTemplate.type as FormFieldType ?? FormFieldType.Text}
                                />
                                <Form.Text>
                                    The type of the parameter
                                </Form.Text>
                            </Form.Group>
                        </div>
                    </div>

                </Confirm>
            )}

            <button
                type="button"
                className="btn btn-primary btn-sm py-1 px-2 mb-2"
                onClick={() => setEditTemplate({})}
            >
                Add
            </button>

            <ul className="list-group">
                {json?.map(parameter => (
                    <li className="list-group-item d-flex justify-content-between">
                        <div>
                            <h5>
                                {parameter.name as string}
                                <small className="text-light ms-2">
                                    {parameter.type as string}
                                </small>
                            </h5>
                            <small>
                                {parameter.description as string}
                            </small>
                        </div>
                        <div>
                            <button
                                className="btn btn-sm btn-none"
                                type="button"
                                onClick={() => {
                                    setEditTemplate(parameter);
                                }}
                            >
                                <BiPencil className="text-light" />
                            </button>

                            <button
                                className="btn btn-sm btn-none"
                                type="button"
                                onClick={() => {
                                    onChange(json.filter(row => row.id !== parameter.id));
                                }}
                            >
                                <BiTrash className="text-light" />
                            </button>

                        </div>

                    </li>
                ))}
            </ul>
        </>
    );
}
